import React from 'react';
import { Eye } from 'lucide-react';
export function MechanismSection() {
  return <section className="py-24 bg-noir-bg border-b border-noir-border relative overflow-hidden" data-id="element-117">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-4xl relative z-10" data-id="element-118">
        <div className="bg-noir-card border border-noir-border p-8 md:p-12 rounded-sm relative shadow-[0_0_30px_rgba(211,47,47,0.1)]" data-id="element-119">
          {/* Decorative corners */}
          <div className="absolute top-0 left-0 w-4 h-4 border-t border-l border-noir-alert" data-id="element-120"></div>
          <div className="absolute bottom-0 right-0 w-4 h-4 border-b border-r border-noir-alert" data-id="element-121"></div>

          <div className="flex flex-col md:flex-row gap-10 items-center" data-id="element-122">
            <div className="flex-shrink-0" data-id="element-123">
              <div className="w-24 h-24 bg-noir-bg border border-noir-border rounded-sm flex items-center justify-center relative" data-id="element-124">
                <Eye className="w-12 h-12 text-noir-alert opacity-80" data-id="element-125" />
                <div className="absolute inset-0 border border-noir-alert/20 rounded-sm" data-id="element-126"></div>
              </div>
            </div>

            <div data-id="element-127">
              <h2 className="text-2xl md:text-3xl font-mono font-bold text-noir-text mb-4 uppercase leading-tight" data-id="element-128">
                Expediente Pareja funciona porque utiliza{' '}
                <span className="text-noir-alert" data-id="element-129">
                  el método de la tercera persona
                </span>
              </h2>

              <div className="space-y-4 text-noir-muted font-sans text-lg" data-id="element-130">
                <p data-id="element-131">
                  Es 10 veces más fácil juzgar los problemas de los demás que
                  los propios.
                </p>
                <p className="text-noir-text border-l-2 border-noir-alert pl-4 py-2 bg-noir-bg/50" data-id="element-132">
                  Al resolver estos 5 casos de 'parejas desconocidas', ustedes
                  proyectarán sus secretos y deseos sin ataques ni defensas.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}